// extracted by mini-css-extract-plugin
module.exports = {"post-list":"feeds_post-list__ablZQ"};